<template>
    <b-navbar toggleable="lg" class="routa-top-panel" fixed="top" type="dark">
        <b-navbar-brand href="#" v-on:click="$emit('scrollTo', 'carousel')">
            <div class="brand-main">ROUTA</div>
            <div class="brand-sub">systems</div>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-navbar-nav>
                    <b-nav-item v-on:click.stop="$emit('scrollTo', 'what')" class="routa-menu-item">{{ $t('menu.what') }}</b-nav-item>
                    <b-nav-item v-on:click.stop="$emit('scrollTo', 'why')" class="routa-menu-item">{{ $t('menu.why') }}</b-nav-item>
                    <b-nav-item v-on:click.stop="$emit('scrollTo', 'content')" class="routa-menu-item">{{ $t('menu.content') }}</b-nav-item>
                    <!--
                    <b-nav-item v-on:click.stop="$emit('scrollTo', 'references')" class="routa-menu-item">{{ $t('menu.references') }}</b-nav-item>
                    -->
                    <b-nav-item v-on:click.stop="$emit('scrollTo', 'contacts')" class="routa-menu-item">{{ $t('menu.contact') }}</b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav>
                    <b-nav-item class="flag" v-on:click.stop="setFinnish"><img src="../assets/finland.png"></b-nav-item>
                    <b-nav-item class="flag" v-on:click.stop="setEnglish"><img src="../assets/uk.png"></b-nav-item>
                </b-navbar-nav>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>

</template>

<script>
export default {
    name: "TopPanel",
    props: ['language'],
    methods: {
        setEnglish: function () {
            this.setLanguage('en')
        },
        setFinnish: function () {
            this.setLanguage('fi')
        },
        setFrench: function () {
            this.setLanguage('fr')
        },
        setLanguage: function(lang) {
            this.$emit('onLanguageSelected', lang)
        }
    }
}
</script>

<style scoped>

</style>
